import React, { ReactNode } from 'react';

import { Box } from '@mui/material';

export type PageHeaderWideProp = {
    icon?: ReactNode;
    title: ReactNode;
    desc: ReactNode;
    accountStatus?: ReactNode;
    showBottomRadiusBorder?: boolean;
    showTopRadiusBorder?: boolean;
};

const PageHeaderWide = ({
    icon,
    title,
    desc,
    accountStatus,
    showBottomRadiusBorder = false,
    showTopRadiusBorder = false,
}: PageHeaderWideProp) => {
    return (
        <Box
            component="div"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                bgcolor: 'background.paper',
                pt: 8,
                pb: 10,
                px: 2,
                ...(showTopRadiusBorder && {
                    mt: 0.25,
                    borderTopLeftRadius: (theme) => theme.shape.borderRadius,
                    borderTopRightRadius: (theme) => theme.shape.borderRadius,
                }),
                ...(showBottomRadiusBorder && {
                    py: 4,
                    mb: 0.25,
                    borderBottomLeftRadius: (theme) => theme.shape.borderRadius,
                    borderBottomRightRadius: (theme) =>
                        theme.shape.borderRadius,
                }),
            }}>
            <Box sx={{ display: 'flex' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        pt: 3,
                        pb: 3,
                    }}
                    data-testid="heading-content">
                    {icon && (
                        <Box
                            sx={{
                                mb: 1,
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                            data-testid="heading-icon">
                            {icon}
                        </Box>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        data-testid="heading-title">
                        {title}
                    </Box>
                    <Box
                        sx={{
                            mb: 1,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        data-testid="heading-description">
                        {desc}
                    </Box>
                    <Box
                        sx={{
                            mb: 1,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        data-testid="heading-account-status">
                        {accountStatus}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PageHeaderWide;
